import { RedirectLoginOptions } from '@auth0/auth0-react';

export const LOGIN_URL_PARAMS = {
    email: 'email',
    google: 'google-oauth2',
    hustro: 'Username-Password-Authentication',
} as const;

export type LoginUrlParam = keyof typeof LOGIN_URL_PARAMS;

export function isLoginUrlParam(value: string | null): value is LoginUrlParam {
    return value !== null && value in LOGIN_URL_PARAMS;
}

export function getRedirectLoginOptions(
    connection: 'google-oauth2' | 'email' | 'Username-Password-Authentication',
): RedirectLoginOptions {
    const returnTo = window.location.pathname;
    const state = btoa(
        JSON.stringify({
            formPath: returnTo,
            timestamp: Date.now(),
        }),
    );
    return {
        authorizationParams: {
            prompt: 'login',
            redirect_uri: window.location.origin,
            connection,
            state,
        },
        appState: { returnTo },
    };
}

export function getRedirectLoginOptionsForUrlParam(
    param: LoginUrlParam,
): RedirectLoginOptions {
    return getRedirectLoginOptions(LOGIN_URL_PARAMS[param]);
}
